import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './components/loader/loader.component';
import { LoginFailedComponent } from './components/login-failed/login-failed.component';
import { MainMenuComponent } from './components/main-menu/main-menu.component';
import { NonEmployeeComponent } from './components/non-employee/non-employee.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { PopupComponent } from './components/popup/popup.component';
import { PopupService } from './components/popup/popup.service';
import { EventsService } from './services/events/events.service';
import { CookiesService } from './services/cookies/cookies.service';
import { DocumentsService } from './services/documents/documents.service';
import { LoginFailedService } from './services/login-failed/login-failed.guard.service';
import { MessagesService } from './services/messages/messages.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { OrchidModule } from '@upmc-healthplan-npm/ods-ng';
import { RenewalPopupComponent } from './components/renewal-popup/renewal-popup.component';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  providers: [EventsService, MessagesService, CookiesService, DocumentsService, LoginFailedService, PopupService],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    OrchidModule,
    LoaderComponent,
    LoginFailedComponent,
    MainMenuComponent,
    NonEmployeeComponent,
    NotFoundComponent,
    PopupComponent,
    RenewalPopupComponent,
    FooterComponent,
  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    OrchidModule,
    LoaderComponent,
    LoginFailedComponent,
    MainMenuComponent,
    NonEmployeeComponent,
    NotFoundComponent,
    PopupComponent,
    RenewalPopupComponent,
    FooterComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
